"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PERFORMANCE_TRACK_EVENT = void 0;
exports.PERFORMANCE_TRACK_EVENT = '@performanceTracking/PERFORMANCE_TRACK_EVENT';